import React, { useState, useEffect, useCallback } from "react";
import "../../Organiser/Events/Events.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsis,
  faEnvelope,
  faKey,
  faUnlockKeyhole,
  faCalendarPlus,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import LoadingScreen from "../../../../LoadingScreen";
import "./ManageUsers.css";

const ManageUsers = () => {
  const [activeOption, setActiveOption] = useState("active");
  const [isLoading, setIsLoading] = useState(true);
  const [expiredLoading, setExpiredLoading] = useState(true);
  const [setting, setSetting] = useState({ flag: false, id: null });
  const [organizers, setOrganizers] = useState(null);
  const [currUser, setCurrUser] = useState(null);
  const [events, setEvents] = useState(null);
  const isMobile = window.innerWidth <= 768;
  const isSmallMobile = window.innerWidth <= 480;

  const handleDeleteUser = async () => {
    try {
      await axios.delete(
        `https://event-finder12.onrender.com/admin/deleteUser/${currUser.email}`
      );
      toast.success("Successfully deleted the user");
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleDisableUser = async () => {
    try {
      await axios.put(
        `https://event-finder12.onrender.com/admin/disableUser/${currUser.email}`
      );
      toast.success("Successfully disabled the user");
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleEnableUser = async () => {
    try {
      await axios.put(
        `https://event-finder12.onrender.com/admin/enableUser/${currUser.email}`
      );
      toast.success("Successfully Enabled the user");
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleSettingSelected = async (option) => {
    if (option === "delete") {
      const confirmed = window.confirm("Are you sure you want to delete?");
      if (confirmed) {
        handleDeleteUser();
      }
    }else if (option === "disable") {
      handleDisableUser();
      setSetting({ flag: false, id: null });
    } else if (option === "enable") {
      handleEnableUser();
      setSetting({ flag: false, id: null });
    }
  };

  const handleOptions = (e) => {
    setActiveOption(e.target.id);
    console.log(e.target.id);
  };

  const getCustomers = async () => {
    try {
      const resp = await axios.get(`https://event-finder12.onrender.com/admin/getcustomers`);
      setEvents(resp.data);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const getTheUser = (eventId) => {
    try {
      const selectedUser = events.find((event) => event.uid === eventId);
      setCurrUser(selectedUser);
    } catch (err) {
      console.log(err);
    }
  };

  const getTheOrganizer = (eventId) => {
    try {
      const selectedUser = organizers.find((event) => event.uid === eventId);
      setCurrUser(selectedUser);
    } catch (err) {
      console.log(err);
    }
  };

  const getAllOrganizers = async () => {
    try {
      const resp = await axios.get(`https://event-finder12.onrender.com/admin/getorganizers`);
      setOrganizers(resp.data);
      setExpiredLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleSettingOptions = (eventId) => {
    if (setting.flag && setting.id === eventId) {
      setSetting({ flag: false, id: null });
    } else {
      setSetting({ flag: true, id: eventId });
      if (activeOption === "active") getTheUser(eventId);
      else getTheOrganizer(eventId);
    }
  };

  useEffect(() => {
    getCustomers();
    getAllOrganizers();
  }, [events, organizers]);


  return (
    <>
      <ToastContainer />
      {isLoading || expiredLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <div className="event-outer-container">
            <div className="event-settings-container">
              <div className="event-header">
                <div className="event-header-title">
                  <h3>Manage Users</h3>
                </div>
                {/* <div onClick={handleCreate} className="event-create-container">
                      + Create
                    </div> */}
              </div>
              <div className="event-options">
                <div
                  onClick={handleOptions}
                  id="active"
                  className={`event-option ${
                    activeOption === "active" ? "active-option" : ""
                  }`}
                >
                  <h4 id="active" className="event-option-title">
                    Customers
                  </h4>
                  <h5 id="active" className="event-option-length">
                    {events?.length}
                  </h5>
                </div>
                <div
                  onClick={handleOptions}
                  id="expired"
                  className={`event-option ${
                    activeOption === "expired" ? "active-option" : ""
                  }`}
                >
                  <h4 id="expired" className="event-option-title">
                    Organisers
                  </h4>
                  <h5 id="expired" className="event-option-length">
                    {organizers?.length}
                  </h5>
                </div>
              </div>
              <div className="event-list-container">
                {activeOption === "active" && events?.length > 0 ? (
                  events.map((event) => (
                    <div
                      className={
                        event.disabled
                          ? "user-info-container sys-admin-info-container disabled-container"
                          : "user-info-container sys-admin-info-container"
                      }
                      key={event._id}
                    >
                      <div className="user-data-first sys-cols">
                        <div className="user-data-first-col">
                          <FontAwesomeIcon
                            icon={faEnvelope}
                            style={{
                              color: event.disabled ? "white" : "#8b8f98",
                            }}
                          />
                          {isMobile && isSmallMobile ?  <h6 className="user-email-margin">Email : </h6> : <></>}
                         
                          <h5 className="user-email">{event.email}</h5>
                        </div>

                        <div className="user-data-first-col sys-mobile-displayWidth">
                          <FontAwesomeIcon
                            icon={faUser}
                            size="md"
                            style={{
                              color: event.disabled ? "white" : "#8b8f98",
                            }}
                          />
                          {isMobile && isSmallMobile? <h6 className="user-email-margin">Name : </h6> : <></>}
                          
                          <h5 className="user-email">{event.displayName}</h5>
                        </div>
                      </div>

                      <div className="user-data-first">
                        <div className="user-data-first-col small-device-sys">
                          <FontAwesomeIcon
                            icon={faUnlockKeyhole}
                            size="md"
                            style={{
                              color: event.disabled ? "white" : "#8b8f98",
                            }}
                          />
                          {
                            isMobile ?   <h6 className="user-email-margin">
                            Last SignedIn :{" "}
                          </h6> : <></>
                          }
                        
                          <h5 className="user-email">
                            {event.metadata.lastSignInTime}
                          </h5>
                        </div>

                        <div className="user-data-first-col small-device-sys">
                    
                          <FontAwesomeIcon
                            icon={faKey}
                            size="md"
                            style={{
                              color: event.disabled ? "white" : "#8b8f98",
                            }}
                          />
                          {isMobile ?<h6 className="user-email-margin">UID : </h6> : <></> }
                          
                          <h5 className="user-email">{event.uid}</h5> 
                        </div>
                      </div>

                      <div className="user-data-first">
                        <div className="user-data-first-col small-device-sys">
                          <FontAwesomeIcon
                            icon={faCalendarPlus}
                            size="md"
                            style={{
                              color: event.disabled ? "white" : "#8b8f98",
                            }}
                          />
                          {isMobile ?   <h6 className="user-email-margin">Created at : </h6> : <></>}
                        
                          <h5 className="user-email">
                            {event.creationTimeFormatted}
                          </h5>
                        </div>

                        <div className="user-data-first-col">
                          <h5 className="disabled-container" style={event.disabled ? { color: "yellow" } : {}}>
                            {event.disabled ? "ACCOUNT DISABLED" : ""}
                          </h5>
                        </div>
                      </div>

                      <div className="settings-div-option">
                        <div className="user-data-first-col">
                          <div
                            onClick={() => handleSettingOptions(event.uid)}
                            className="event-info-settings"
                          >
                            <FontAwesomeIcon icon={faEllipsis} />
                          </div>
                          {setting.flag && setting.id === event.uid && (
                            <ul
                              className={
                                !event.disabled
                                  ? "setting-user-options"
                                  : "setting-user-options disable-background"
                              }
                            >
                              <li
                                id="delete"
                                onClick={() => handleSettingSelected("delete")}
                              >
                                Delete Account
                              </li>
                              {!event.disabled ? (
                                <li
                                  id="disable"
                                  onClick={() =>
                                    handleSettingSelected("disable")
                                  }
                                >
                                  Disable Account
                                </li>
                              ) : (
                                <li
                                  id="enable"
                                  onClick={() =>
                                    handleSettingSelected("enable")
                                  }
                                >
                                  Enable Account
                                </li>
                              )}
                            </ul>
                          )}
                        </div>
                      </div>

                      <div className="user-data-first-col"></div>
                    </div>
                  ))
                ) : activeOption === "expired" && organizers.length > 0 ? (
                  organizers.map((event) => (
                    <div
                    className={
                      event.disabled
                        ? "user-info-container sys-admin-info-container disabled-container"
                        : "user-info-container sys-admin-info-container"
                    }
                    key={event._id}
                  >
                    <div className="user-data-first sys-cols">
                      <div className="user-data-first-col">
                        <FontAwesomeIcon
                          icon={faEnvelope}
                          style={{
                            color: event.disabled ? "white" : "#8b8f98",
                          }}
                        />
                        {isMobile && isSmallMobile ?  <h6 className="user-email-margin">Email : </h6> : <></>}
                       
                        <h5 className="user-email">{event.email}</h5>
                      </div>

                      <div className="user-data-first-col sys-mobile-displayWidth">
                        <FontAwesomeIcon
                          icon={faUser}
                          size="md"
                          style={{
                            color: event.disabled ? "white" : "#8b8f98",
                          }}
                        />
                        {isMobile && isSmallMobile? <h6 className="user-email-margin">Name : </h6> : <></>}
                        
                        <h5 className="user-email">{event.displayName}</h5>
                      </div>
                    </div>

                    <div className="user-data-first">
                      <div className="user-data-first-col small-device-sys">
                        <FontAwesomeIcon
                          icon={faUnlockKeyhole}
                          size="md"
                          style={{
                            color: event.disabled ? "white" : "#8b8f98",
                          }}
                        />
                        {
                          isMobile ?   <h6 className="user-email-margin">
                          Last SignedIn :{" "}
                        </h6> : <></>
                        }
                      
                        <h5 className="user-email">
                          {event.metadata.lastSignInTime}
                        </h5>
                      </div>

                      <div className="user-data-first-col small-device-sys">
                  
                        <FontAwesomeIcon
                          icon={faKey}
                          size="md"
                          style={{
                            color: event.disabled ? "white" : "#8b8f98",
                          }}
                        />
                        {isMobile ?<h6 className="user-email-margin">UID : </h6> : <></> }
                        
                        <h5 className="user-email">{event.uid}</h5> 
                      </div>
                    </div>

                    <div className="user-data-first">
                      <div className="user-data-first-col small-device-sys">
                        <FontAwesomeIcon
                          icon={faCalendarPlus}
                          size="md"
                          style={{
                            color: event.disabled ? "white" : "#8b8f98",
                          }}
                        />
                        {isMobile ?   <h6 className="user-email-margin">Created at : </h6> : <></>}
                      
                        <h5 className="user-email">
                          {event.creationTimeFormatted}
                        </h5>
                      </div>

                      <div className="user-data-first-col">
                        <h5 className="disabled-container" style={event.disabled ? { color: "yellow" } : {}}>
                          {event.disabled ? "ACCOUNT DISABLED" : ""}
                        </h5>
                      </div>
                    </div>

                    <div className="settings-div-option">
                      <div className="user-data-first-col">
                        <div
                          onClick={() => handleSettingOptions(event.uid)}
                          className="event-info-settings"
                        >
                          <FontAwesomeIcon icon={faEllipsis} />
                        </div>
                        {setting.flag && setting.id === event.uid && (
                          <ul
                            className={
                              !event.disabled
                                ? "setting-user-options"
                                : "setting-user-options disable-background"
                            }
                          >
                            <li
                              id="delete"
                              onClick={() => handleSettingSelected("delete")}
                            >
                              Delete Account
                            </li>
                            {!event.disabled ? (
                              <li
                                id="disable"
                                onClick={() =>
                                  handleSettingSelected("disable")
                                }
                              >
                                Disable Account
                              </li>
                            ) : (
                              <li
                                id="enable"
                                onClick={() =>
                                  handleSettingSelected("enable")
                                }
                              >
                                Enable Account
                              </li>
                            )}
                          </ul>
                        )}
                      </div>
                    </div>

                    <div className="user-data-first-col"></div>
                  </div>
                  ))
                ) : (
                  <h1 className="no-event">No User</h1>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ManageUsers;
